import { IndexedDbCollectionRepository, IndexedDbDataAccess } from '@softline/core';
import { SOFTLINE_NAME_USER_INDEXED_DB } from '../../softapps-core.shared';

export abstract class UserIndexedDbCollectionRepository<TItem> extends IndexedDbCollectionRepository<TItem, {userId: number}> {

  protected constructor(dataAccess: IndexedDbDataAccess,
                        objectStoreName: string) {
    super(dataAccess, SOFTLINE_NAME_USER_INDEXED_DB, objectStoreName)
  }
}
